import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-windows_phone",
  "use": "icon-windows_phone-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-windows_phone\"><defs><style type=\"text/css\"></style></defs><path d=\"M485.052 80.842L1024 0v479.664H485.052z\" fill=\"#90C300\" p-id=\"1536\" /><path d=\"M0 150.906l413.192-61.082v395.228H0z\" fill=\"#F8672C\" p-id=\"1537\" /><path d=\"M485.052 943.158L1024 1024V556.912H485.052z\" fill=\"#FFC400\" p-id=\"1538\" /><path d=\"M0 873.094l413.192 61.082V556.912H0z\" fill=\"#00B4F2\" p-id=\"1539\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/uas/windows_phone.svg
// module id = 9Byh
// module chunks = 16